import React from 'react';
import styles from './Viva.module.css';
import viva from '../../Assets/viva-banner.jpeg';
import { Link } from 'react-router-dom';

const Viva = () => {
  return (
    <section className={styles.containerPrincipal}>
      <div className={styles.divPrincipal}>
        <img src={viva} alt="Banner Viva" />
      </div>
    </section>
  );
};

export default Viva;
